import React from "react";
import { compose, withHandlers } from "recompose";
import { LocalForm, actions } from "react-redux-form";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  required,
  SubmitButton,
} from "components/common";
import { ReportContainer } from "./components";
import BackButton from "components/refactoring/BackButton";

export const BankStatement = ({ data, item, handleSubmit, setState }) => {


const dynamicUrl = `https://go.xero.com/app/manual-transaction-upload/${
    window.location.href.split('bank_statement/')[1]
  }`;

const rowLength = data?.Rows?.find(row => row?.RowType === "Section")?.Rows.length || 0

const firstCellValue = data?.Rows?.find(row => row?.RowType === "Section")?.Rows?.[0]?.Cells?.[6]?.Value > 0

  return (

  
  <Page title={data.ReportTitles[0]} translate={false}>
    <BackButton/>
    <LocalForm
      className="d-print-none"
      getDispatch={(dispatch) => setState({ dispatch })}
      onSubmit={handleSubmit}
      initialState={item}
      validators={{
        fromDate: { required },
        toDate: { required },
      }}
    >
      <div className="d-flex align-items-center">
        <FormGroup label="Date" className="mr-3">
          <DatePicker model=".fromDate" className="form-control" />
        </FormGroup>
        <FormGroup label="To Date" className="mr-3">
          <DatePicker model=".toDate" className="form-control" />
        </FormGroup>
        <FormGroup label="&nbsp;">
          <SubmitButton size="sm" className="d-block">
            Update
          </SubmitButton>
        </FormGroup>
      </div>
    </LocalForm>
    <div>
      <a 
        className="float-right btn btn-primary d-print-none" 
        target="_blank"
        href={dynamicUrl}
        >Import Statement (Xero)</a>
    </div>
    {data && firstCellValue ?( 
       <ReportContainer report={data} />
       ) : (
        <div className="pt-5 text-center"> 
          <h4>No Bank Statement Data Found</h4>
          <p className="m-0">Please Upload your bank statement through Xero to display it here.</p>
          <p>Or you can add your bank transfers manually.</p>
        </div>
    )}
  </Page>
)};

const loadReport = (item, xero) =>
  xero
    .get("reports/BankStatement", {
      params: {
        extra_params: item,
      },
    })
    .get("data");

export const enhance = compose(
  onMount(({ xero, match }) => () => {
    const item = {
      bankAccountID: match.params.id,
    };

    return Promise.props({
      data: loadReport(item, xero),
      item,
    });
  }),
  withHandlers({
    handleSubmit:
      ({ setState, xero, dispatch }) =>
      (item) => {
        return loadReport(item, xero)
          .then((data) => setState({ data }))
          .finally(() => dispatch(actions.setSubmitted("local", true)));
      },
  })
);

export default enhance(BankStatement);
